export default {"src":"/_next/static/media/modern-dimensional-chain.a6dca3f7.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};